import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { Company } from "../../models/company";
import { AppConfig } from "../../config/app.config";
import { DataProvider } from "../data/data";

const ROUTE = '/api/companies/';

@Injectable()
export class CompanyProviderMock {
    constructor(){
    }

    async getStoreCompany(): Promise<Company> {
        var x = new Company();
        x.name = 'Company Name';
        x.city = 'Venlo';
        return x;
    }
}


// WEBPACK FOOTER //
// ./src/providers/company/company-mock.ts